export var WECOM_APP_CSRF_KEY = 'OzVyegR7jDhE@u74BA8!P<K~2_tx^\\3W';
export var DELAY_POST_REPORT_MAX_COUNT = 10;
export var DELAY_POST_REPORT_DELAY_TIME = 500;